import { SelectionModel } from "@angular/cdk/collections";
import { Component, OnInit } from "@angular/core";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { take } from "rxjs/operators";
import { PromoCode } from "src/models/promo-code";
import { CareplusPromoCodeService } from "src/services/careplus-promo-code.service";

@Component({
  selector: "app-careplus-promo-code",
  templateUrl: "./careplus-promo-code.component.html",
  styleUrls: ["./careplus-promo-code.component.css"],
})
export class CareplusPromoCodeComponent implements OnInit {
  displayedColumns: string[] = [
    "promotionName",
    "couponCode",
    "insurerCode",
    "startDate",
    "endDate",
    "promotionBenfits",
    "discountAmountValue",
    "percentageValue",
    "rewardCreditValue",
    "approval",
    "status",
    "optionMenu",
  ];

  dataSource: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);

  constructor(
    private promoCodeService: CareplusPromoCodeService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {
    this.loadPromoCodes();
  }

  ngOnInit() {}

  toggleStatus(promoCode: PromoCode) {
    this.promoCodeService.toggleStatus(promoCode.couponCode).subscribe((x) => {
      this._snackBar.open("Updated Successfully", "OK", { duration: 3000 });
      this.loadPromoCodes();
    });
  }

  loadPromoCodes() {
    this.promoCodeService
      .getPromoCode()
      .pipe(take(1))
      .subscribe((x) => (this.dataSource = new MatTableDataSource(x)));
  }
}
